import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('lg')]: {
        display: 'grid',
        gridTemplateColumns: 'auto auto'
    },

    '.LocationsMapTitleWrapper': {
        maxWidth: toRem(480),

        '.subtitle': {
            fontSize: toRem(18)
        },

        [theme.breakpoints.down('md')]: {
            padding: toRems([0, 20])
        }
    }
})

export default style
